import moment from "moment";
import { CalendarViewType } from "../../types/account/enum";

/**
 * React Big Calendar의 weekly/daily 뷰에서 특정 요일의 .rbc-day-bg 요소를 찾습니다
 */
export const findWeeklyDayBgElement = (date: Date): HTMLElement | null => {
  const dayOfWeek = moment(date).day(); // 0(일요일) ~ 6(토요일)
  const dayBgElements = document.querySelectorAll(".rbc-day-bg");
  return (
    (dayBgElements[dayOfWeek] as HTMLElement) ||
    (document.querySelector(".rbc-day-bg") as HTMLElement)
  );
};

/**
 * React Big Calendar의 monthly 뷰에서 특정 날짜의 .rbc-day-bg 또는 .rbc-date-cell 요소를 찾습니다
 */
export const findMonthlyDayBgElement = (date: Date): HTMLElement | null => {
  const targetDate = moment(date).date(); // 날짜 (1-31)

  // 모든 date-cell에서 해당 날짜 찾기
  const allDateCells = document.querySelectorAll(".rbc-date-cell");
  for (let i = 0; i < allDateCells.length; i++) {
    const cell = allDateCells[i];
    const dateButton = cell.querySelector(".rbc-button-link");
    if (dateButton && parseInt(dateButton.textContent || "0") === targetDate) {
      // day-bg를 찾거나 date-cell 자체 반환
      return (cell.querySelector(".rbc-day-bg") as HTMLElement) || (cell as HTMLElement);
    }
  }
  return null;
};

/**
 * React Big Calendar에서 뷰 타입과 날짜에 따라 적절한 DOM 요소들을 찾습니다
 */
export const findCalendarElements = (
  date: Date,
  calendarView: CalendarViewType
): {
  closestAlldayElement: HTMLElement | null;
  closestMonthlyElement: HTMLElement | null;
} => {
  const closestAlldayElement = findWeeklyDayBgElement(date);
  const closestMonthlyElement = calendarView === "month" ? findMonthlyDayBgElement(date) : null;

  return {
    closestAlldayElement,
    closestMonthlyElement,
  };
};
